import React from 'react'
import DropdownMenu from '~/Common-Objects/UI/DropdownMenu'
import Icon from '~/Common-Objects/UI/Icon'
import * as styles from './index.module.scss'
import i18n from '~/i18n'

export default function InboxFilterDropdown({
    disabled = false,
    users = [],
    currentOrder = 'newest',
    currentFilterUser = 0,
    conversationsSearchChannel,
    changeFilters = () => {},
    activeInbox
}) {
    return (
        <DropdownMenu.Root>
            <DropdownMenu.Trigger
                disabled={disabled}
                variant='ghost'
                size='s'
                dropDownIconType='filter'
                className={styles.trigger}
            >
                <span style={{ textTransform: 'capitalize' }}>{i18n.t('chat:inbox.leftBar.filter')}</span>
            </DropdownMenu.Trigger>

            <DropdownMenu.Portal>
                <DropdownMenu.Content align='start'>
                    <DropdownMenu.Label>{i18n.t('chat:inbox.leftBar.sortOrder')}</DropdownMenu.Label>
                    <DropdownMenu.RadioGroup
                        value={currentOrder}
                        onValueChange={(val) => {
                            changeFilters(undefined, val, undefined, undefined)
                        }}
                    >
                        <DropdownMenu.RadioItem value='newest'>
                            {i18n.t('chat:inbox.leftBar.newest')}
                        </DropdownMenu.RadioItem>
                        <DropdownMenu.RadioItem value='oldest'>
                            {i18n.t('chat:inbox.leftBar.oldest')}
                        </DropdownMenu.RadioItem>
                    </DropdownMenu.RadioGroup>

                    <DropdownMenu.Separator />

                    <DropdownMenu.Label>{i18n.t('chat:inbox.leftBar.agent')}</DropdownMenu.Label>
                    <DropdownMenu.RadioGroup
                        value={currentFilterUser}
                        onValueChange={(val) => {
                            changeFilters(undefined, undefined, undefined, val)
                        }}
                    >
                        <DropdownMenu.RadioItem value={0}>
                            {i18n.t('chat:inbox.leftBar.everyone')}
                        </DropdownMenu.RadioItem>
                        {users.map((user) => {
                            let userName = user.firstName + ' ' + user.lastName
                            if (!user.firstName && !user.lastName) {
                                userName = user.emailAddress
                            }
                            return (
                                <DropdownMenu.RadioItem key={'user_dd_' + user.id} value={user.id}>
                                    {userName}
                                </DropdownMenu.RadioItem>
                            )
                        })}
                    </DropdownMenu.RadioGroup>

                    {activeInbox?.InboxChannels?.length > 1 && (
                        <>
                            <DropdownMenu.Label>{i18n.t('chat:inbox.leftBar.channel')}</DropdownMenu.Label>
                            <DropdownMenu.RadioGroup
                                value={conversationsSearchChannel}
                                onValueChange={(val) => {
                                    changeFilters(undefined, undefined, undefined, undefined, val)
                                }}
                            >
                                <DropdownMenu.RadioItem value={''}>
                                    {i18n.t('chat:inbox.leftBar.allChannels')}
                                </DropdownMenu.RadioItem>
                                {activeInbox.InboxChannels.map((channel) => {
                                    return (
                                        <DropdownMenu.RadioItem
                                            key={'channel_dd_' + channel.id}
                                            value={channel.id}
                                        >
                                            {channel.name}
                                            <Icon
                                                color='var(--neutral-400)'
                                                name={parseChannelTypeIcon(channel?.type)}
                                                style={{ height: 16, width: 16 }}
                                            />
                                        </DropdownMenu.RadioItem>
                                    )
                                })}
                            </DropdownMenu.RadioGroup>
                        </>
                    )}
                </DropdownMenu.Content>
            </DropdownMenu.Portal>
        </DropdownMenu.Root>
    )
}

function parseChannelTypeIcon(type) {
    switch (type) {
        case 1:
            return 'mail-open'
        case 2:
            return 'chat'
        case 3:
            return 'facebook'
    }
}
